<template>
    <section class="wrapper flex flex-wrap mt-2">
        <div v-for="(item, index) in products" :key="index" class="wrapper__item w-1/6 px-2 mb-4">
            <a href="/" class="wrapper__link h-full w-full flex flex-col items-center bg-white relative">
                <div :style="url(item.thumbnail)" class="wrapper__item__img w-full h-4/6 bg-top bg-cover bg-no-repeat"></div>
                <div class="wrapper__item__bottom w-full flex-1 flex flex-col pb-4">
                    <h3 class="wrapper__item__bottom__name flex-1 py-2 text-2xl">{{ item.title }}</h3>
                    <div class="flex items-center justify-between text-2xl pt-2 w-full">
                        <div class="ml-4 text-primary-color ">{{ item.price }} บาท</div>
                        <div class="mr-4 mt-1 text-base">ขายแล้ว {{ item.stock }}</div>
                    </div>
                </div>

                <div class="wrapper__link__label-favorite absolute">
                    <span>ขายดี</span>
                </div>
                <div class="wrapper__link__label-mall absolute bg-red-color">
                    <span>Mall</span>
                </div>
                <div v-if="item.discountPercentage != 0"
                    class="wrapper__link__label-discount absolute flex justify-center items-center flex-col bg-yellow-color">
                    <span class="text-primary-color">{{ item.discountPercentage }}%</span>
                </div>
            </a>
        </div>
    </section>
</template>

<script>
import axios from 'axios';

export default {
    name: 'ProductWrapperItem',
    data() {
        return {
            products: []
        }
    },
    created() {
        axios.get('https://dummyjson.com/products')
            .then(response => {
                this.products = response.data.products;
            })
            .catch(error => {
                console.error('There was an error fetching the data :', error);
            });
    },
    methods: {
        url: function (url) {
            return `background-image: url(${url});`;
        }
    }
}
</script>

<style scoped>
.wrapper__item {
    height: 29.7rem;
}

.wrapper__link {
    box-shadow: 1px 1px 5px rgba(0, 0, 0, .3);
}

.wrapper__link:hover {
    border: 1px solid var(--primary-color);
    transform: translateY(-2px);
    transition: transform .1s
}

.wrapper__item__bottom__name {
    color: var(--text-color);
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 3;
    overflow: hidden;
}

.wrapper__link__label-favorite {
    top: .5rem;
    left: -.5rem;
    height: 20px;
    width: 6rem;
    background-color: var(--primary-color);
    color: var(--white-color);
    font-size: 1.2rem;
}

.wrapper__link__label-favorite::before {
    content: "";
    position: absolute;
    left: 0;
    bottom: -3px;
    border-top: 3px solid var(--primary-color);
    border-left: 3px solid transparent;
    filter: brightness(60%);
}

.wrapper__link__label-mall {
    top: 2.8rem;
    left: -.5rem;
    height: 20px;
    width: 3rem;
    color: var(--white-color);
    font-size: 1.2rem;
}

.wrapper__link__label-mall::before {
    content: "";
    position: absolute;
    left: 0;
    bottom: -3px;
    border-top: 3px solid var(--primary-color);
    border-left: 3px solid transparent;
    filter: brightness(50%);
}

.wrapper__link__label-discount {
    top: 0;
    right: 0;
    width: 3.2rem;
    height: 3.2rem;
    font-size: 1.2rem;
}

.wrapper__link__label-discount::before {
    content: '';
    position: absolute;
    display: block;
    border-width: 1px 16px 6px;
    border-style: solid;
    bottom: -6px;
    border-color: #ffd839 #ffd839 transparent #ffd839;
}

.see-more {
    border: 1px solid #ddd;
}

.see-more:hover {
    background: rgba(0, 0, 0, .02);
}

/* mobile & tablet */
@media (max-width: 1023px) {
    .wrapper {
        margin: 0 2rem;
    }

    .wrapper__item {
        width: 25%;
    }
}

/* mobile */
@media (max-width: 739px) {
    .wrapper {
        margin: 0 .5rem;
    }

    .wrapper__item {
        width: 50%;
    }
}
</style>
